import { render, staticRenderFns } from "./DmPlatformForm.vue?vue&type=template&id=0a65647b&scoped=true"
import script from "./DmPlatformForm.vue?vue&type=script&lang=js"
export * from "./DmPlatformForm.vue?vue&type=script&lang=js"
import style0 from "./DmPlatformForm.vue?vue&type=style&index=0&id=0a65647b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a65647b",
  null
  
)

export default component.exports